/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Invite_ExpiredInputs */

const nl_invite_errors_invite_expired = /** @type {(inputs: Invite_Errors_Invite_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze uitnodiging is verlopen. Vraag de school om een nieuwe uitnodiging te versturen.`)
};

/**

* @param {Invite_Errors_Invite_ExpiredInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_invite_expired = /** @type {((inputs?: Invite_Errors_Invite_ExpiredInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Invite_ExpiredInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_invite_expired(inputs)
});
export { invite_errors_invite_expired as "invite.errors.invite_expired" }